import styled from "styled-components";

export const ButtonGroupContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
`;

export const GroupButtonContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ numberOfItems }) =>
    `repeat(${numberOfItems}, 1fr)`};
  background-color: ${({ theme }) => theme.bg.primary};
  border-radius: 8px;
  padding: 4px;
  gap: 2px;
  width: 100%;
`;

export const GroupButton = styled.div`
  height: 32px;
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.border.black15 : "transparent"};
  border-radius: 4px;
  display: grid;
  place-content: center;
  font-size: 12px;
  cursor: pointer;
`;

export const GroupInput = styled.input`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: baseline;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.border.black15};
  text-align: center;

  &:focus {
    outline: none;
  }
`;
